"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
require("./index.scss");
const api_1 = require("core/api");
const useAmpli_1 = require("src/hooks/useAmpli");
const useFeatureFlag_1 = require("src/hooks/useFeatureFlag");
const useNavigation_1 = require("src/hooks/useNavigation");
const useSelectPlan_1 = require("../useSelectPlan");
const FreePlanCard_1 = __importDefault(require("./FreePlanCard"));
const FreePlanModal_1 = __importDefault(require("./FreePlanModal"));
const PlanCard_1 = __importDefault(require("./PlanCard"));
const PlanFrequencySelector_1 = __importDefault(require("./PlanFrequencySelector"));
const PlanHeader_1 = __importDefault(require("./PlanHeader"));
const SelectPlan = () => {
    const { products, groupItems, setFrequency, teamId, choosePlan, isProcessing, basicAvailable, selectedId, isTrial, loaded, group, checkoutContext, } = (0, useSelectPlan_1.useSelectPlan)();
    const { navigate } = (0, useNavigation_1.useNavigation)();
    const { freeTeamSelected, pricingViewed } = (0, useAmpli_1.useAmpli)();
    (0, useFeatureFlag_1.useFeatureFlag)('teamPlan');
    const [isFreePlanModalOpen, setIsFreePlanModalOpen] = React.useState(false);
    React.useEffect(() => {
        if (loaded) {
            pricingViewed(!!isTrial, basicAvailable, useAmpli_1.AmplitudeScreenNames.PLAN_SELECT_2025);
        }
    }, [loaded]);
    const openFreePlanModal = () => {
        setIsFreePlanModalOpen(true);
    };
    const closeFreePlanModal = () => {
        setIsFreePlanModalOpen(false);
    };
    const onChooseFreePlan = () => {
        freeTeamSelected();
        closeFreePlanModal();
        // @ts-ignore
        if (window?.webkit?.messageHandlers?.webCheckoutObserver) {
            // @ts-ignore
            window.webkit.messageHandlers.webCheckoutObserver.postMessage({
                event: 'flowCancelled',
            });
            return;
        }
        if (checkoutContext === api_1.CheckoutContext.ONBOARDING) {
            navigate.chooseFreePlan(teamId);
        }
        else {
            navigate.classicTeamBilling();
        }
    };
    const premiumPriceId = (0, react_1.useMemo)(() => products.find((p) => p.title === 'TeamSnap Premium')?.priceId, [products]);
    const onlyTwoOptions = (0, react_1.useMemo)(() => products.length === 2, [products]);
    return (React.createElement("main", { className: "SelectPlanNew" }, !loaded ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
        React.createElement(PlanHeader_1.default, { isTrial: isTrial }),
        React.createElement("div", { className: "sui-flex sui-justify-center sui-items-center sui-mb-2 d:sui-mb-3" },
            React.createElement(PlanFrequencySelector_1.default, { groupItems: groupItems, setFrequency: setFrequency })),
        React.createElement("section", { className: "plan-group sui-px-2 d:sui-flex d:sui-justify-center d:sui-gap-3 d:sui-px-4" }, products.map((product) => (React.createElement(PlanCard_1.default, { key: product.priceId, product: product, isProcessing: isProcessing, selectedId: selectedId, onChoosePlan: choosePlan, frequency: group ? group['frequency'] : 'year', onlyTwoOptions: onlyTwoOptions })))),
        React.createElement("section", null,
            React.createElement(FreePlanCard_1.default, { onClick: openFreePlanModal })),
        React.createElement(FreePlanModal_1.default, { isOpen: isFreePlanModalOpen, onClose: closeFreePlanModal, onConfirm: () => choosePlan(premiumPriceId ?? ''), onChooseFreePlan: onChooseFreePlan })))));
};
exports.default = SelectPlan;
